var tablink = document.querySelectorAll('.tablink');

for (var i = tablink.length - 1; i >= 0; i--) {
	tablink[i].addEventListener('click', function(e){
		e.preventDefault();
		changeTab(e, this);
	});
};

function changeTab(e, link) {
	var li = link.parentNode;
	var prevLi = li.previousElementSibling;
	var nextLi = li.nextElementSibling;
	var tabName = link.hash.replace("#", "");
	var tabsName = link.dataset.tabs;

	if (prevLi !== null) {
		prevLi.classList.add('is-visited');
	} else {
		nextLi.classList.remove('is-visited');
	}


	// Get all elements with class="tab" and hide them
	var tabContent = document.querySelectorAll(".tab[data-tabs='"+ tabsName +"']");
	for (var i = 0; i < tabContent.length; i++) {
		tabContent[i].classList.add('is-hidden-desktop');
	}

	// Get all elements with class="tablink" and remove the class "is-active"
	var tablinks = document.querySelectorAll(".tablink[data-tabs='"+ tabsName +"']");
	for (var i = 0; i < tablinks.length; i++) {
		tablinks[i].parentNode.classList.remove('is-active');
	}

	// Show the current tab, and add an "is-active" class to the tablink that opened the tab
	document.getElementById(tabName).classList.remove('is-hidden-desktop');
	li.classList.add('is-active');
}